import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { actions as debinActions } from "reducers/debin";
import * as i18n from "util/i18n";
import { actions as notificationActions } from "reducers/notification";
import Image from "pages/_components/Image";
import PayDebinSummaryBody from "./components/Summary";

const PayDebinSummaryPage = () => {
    const { debinDetail, sentRequests, debinTicket } = useSelector((state) => state.debin);
    const { accounts } = useSelector((state) => state.accounts);
    const receivedDebin = sentRequests?.debinList?.find((object) => object.id === debinDetail?.id);
    const accountBuyer = accounts?.find((object) => object?.cbu?.substring(9) === receivedDebin?.buyer?.cbu);
    const dispatch = useDispatch();
    const accountB = accountBuyer
        ? {
              ...accountBuyer,
              cbu: accountBuyer?.cbu?.substring(9),
          }
        : null;
    const branch = debinDetail?.sellerDetail?.branch;
    const bank = debinDetail?.sellerDetail?.bank;
    const documentType = debinDetail?.sellerDetail?.documentType;
    const documentNumber = debinDetail?.sellerDetail?.documentNumber;
    const bankBranch = bank || branch ? `${bank} / ${branch}` : null;
    const debitAccountMask = accountBuyer?.shortLabel ? `****${accountBuyer?.shortLabel?.substring(1)}` : null;
    const sellerCuit = documentType || documentNumber ? `${documentType} ${documentNumber}` : null;
    const sumaryBody = {
        sellerName: debinDetail?.sellerDetail?.titular || debinDetail?.sellerName || "-",
        sellerCuit: sellerCuit || debinDetail?.sellerCuit || "-",
        amountSumary: debinDetail?.amount?.quantity || debinDetail?.amountSumary,
        solicitDate: debinDetail?.creationDate || debinDetail?.solicitDate || "-",
        dueDate: debinDetail?.expirationDate || debinDetail?.dueDate || "-",
        debinId: debinDetail?.id || debinDetail?.debinId || "-",
        sellerCbu: debinDetail?.sellerDetail?.cbu || debinDetail?.sellerCbu || "-",
        alias: debinDetail?.sellerDetail?.cbuAlias || debinDetail?.alias || "-",
        bank: bankBranch || debinDetail?.bank || "-",
        concept: debinDetail?.concept || "-",
        description: debinDetail?.description || "-",
        reference: debinDetail?.reference || "-",
        curencySeller: debinDetail?.amount?.currency || debinDetail?.curencySeller || "-",
        debitAccountMask: debitAccountMask || debinDetail?.debitAccountMask,
    };
    const data = {
        ...sumaryBody,
        currency: debinDetail?.amount?.currency || debinDetail?.currency,
        idDebin: debinDetail?.id || debinDetail?.idDebin,
        idAccount: accountBuyer?.productId || debinDetail?.idAccount,
        idVoucher: debinDetail?.idVoucher,
        amount: debinDetail?.amount,
        debitAccount: accountB || debinDetail?.debitAccount,
        sellerDetail: debinDetail?.sellerDetail,
        debinDetail,
        idTransaction: debinDetail?.idTransaction,
    };

    useConfirmTransaction(debinDetail, debinTicket, "debinPayments/pay", true);

    const [hideButton, setHideButton] = useState(false);
    let message;
    useEffect(() => {
        if (!debinDetail?.idTransaction) {
            if (accountBuyer?.availableBalance && debinDetail?.amount?.quantity) {
                if (accountBuyer?.availableBalance < debinDetail?.amount?.quantity) {
                    message = i18n.get("debin.insuficient.funds");
                    dispatch(notificationActions.showNotification(message, "error", ["debinActionPay"]));
                    setHideButton(true);
                } else {
                    setHideButton(false);
                }
            } else {
                setHideButton(true);
            }
        } else {
            setHideButton(false);
        }
    }, [accountBuyer, debinDetail]);

    return (
        <>
            <Notification scopeToShow="debinActionPay" />
            <ResponsiveHeader id="debin.pay.received" />
            <MainContainer
                showLoader={
                    !debinDetail?.idTransaction
                        ? !accountBuyer?.availableBalance
                        : !debinDetail?.debitAccount?.availableBalance
                }>
                <div className="container debin-payments__pay">
                    <h2>
                        <I18n id="debin.pay.summary.confirm" />
                    </h2>
                    <PayDebinSummaryBody
                        debitAccountMask={debitAccountMask || debinDetail?.debitAccountMask || "-"}
                        sellerName={debinDetail?.sellerDetail?.titular || debinDetail?.sellerName || "-"}
                        sellerCuit={sellerCuit || debinDetail?.sellerCuit || "-"}
                        curencySeller={debinDetail?.amount?.currency || debinDetail?.curencySeller || "-"}
                        amountSumary={debinDetail?.amount?.quantity || debinDetail?.amountSumary || "-"}
                        solicitDate={debinDetail?.creationDate || debinDetail?.solicitDate || "-"}
                        dueDate={debinDetail?.expirationDate || debinDetail?.dueDate || "-"}
                        debinId={debinDetail?.id || debinDetail?.debinId || "-"}
                        sellerCbu={debinDetail?.sellerDetail?.cbu || debinDetail?.sellerCbu || "-"}
                        alias={debinDetail?.sellerDetail?.cbuAlias || debinDetail?.alias || "-"}
                        bank={bankBranch || debinDetail?.bank || "-"}
                        concept={debinDetail?.concept || "-"}
                        description={debinDetail?.description || "-"}
                        reference={debinDetail?.reference || "-"}
                    />
                    <div className="box info service-payments__no-data my-6">
                        <Image src="images/information_fill.svg" className="svg-icon" />{" "}
                        <I18n id="debin.alert.message" />
                    </div>
                    <GeneralCredentialForm
                        transactionData={data}
                        action={debinActions.acceptIncomingRequestSend}
                        idActivity="debin.incoming.accept.send"
                        hideIndications
                        hasTerms
                        messageSnackBar={message}
                        hideButton={hideButton}
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default PayDebinSummaryPage;
